<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState(['user'])
    }
  }
</script>
<style>
  .nav .router-link-active {
    border-bottom: 3px solid #00d1b2;
    color: #00d1b2;
    padding-bottom: calc(0.75rem - 3px);
  }
</style>
<template>
  <nav class="nav has-shadow" id="top">
    <div class="container">
      <div class="nav-left">
        <a class="nav-item" href="/">
          <img src="../../images/studio33.png" />
        </a>
      </div>
      <span class="nav-toggle">
        <span></span>
        <span></span>
        <span></span>
      </span>
      <div class="nav-right nav-menu">
        <router-link v-if="user.id" to="/addresses" class="nav-item">
          Addresses &amp; Photos
        </router-link>
        <router-link to="/users" v-if="user.gates && user.gates.users" class="nav-item">
          Users
        </router-link>
        <router-link to="/login" v-if="!user.id" class="nav-item">
          Login
        </router-link>
        <router-link to="/logout" v-if="user.id" class="nav-item">
          Logout
        </router-link>
      </div>
    </div>
  </nav>
</template>
